<template>
	<div class="excel-dialog">
		<el-dialog :visible.sync="dialogShow" width="929px" :close-on-click-modal="true" @closed="handleClosed">
			<div class="dialog-member-title">
				<span class="dialog-member-name">复用申请人</span>
				<div class="dialog-close" @click="closeFn">
					<i class="el-icon-close"></i>
				</div>
			</div>
			<!-- 选择产品复用下单 -->
			<div style="margin-top: 20px;display: flex;align-items: center;justify-content: space-between;">
				<div style="display: flex;gap: 20px;">
					<div>
						<span>选择产品: </span>
						<!-- 选择要批量的产品id -->
						<el-select clearable v-model="visaId" @change="handleDataChange" style="width: 240px" placeholder="必选产品"
							filterable autocomplete="off" remote :remote-method="handleGetordertools" :loading="productloading">
							<el-option v-for="item in productList" :key="item.id" :label="item.title" :value="item.id">
							</el-option>
						</el-select>
					</div>
					<!-- 预计出行时间 -->
					<div>
						<span>预计出行日期: </span>
						<el-date-picker v-model="departureTime" type="date" placeholder="选择出行时间" value-format="yyyy-MM-dd">
						</el-date-picker>
						<!-- <el-select clearable v-model="visaId" @change="handleDataChange" style="width: 240px" placeholder="必选产品" filterable
						autocomplete="off" remote :remote-method="handleGetordertools" :loading="productloading">
						<el-option v-for="item in productList" :key="item.id" :label="item.title"
							:value="item.id">
						</el-option>
					</el-select> -->
					</div>
				</div>



				<!-- 点击批量下单 -->
				<el-button type="primary" @click="submitSelectionUpload">确认下单</el-button>
			</div>
			<!-- 数据展示表单 -->
			<el-table :data="tableData" style="width: 100%;margin-top: 20px;" height="500px" ref="tableReuseRef"
				@selection-change="handleSelectionChange">
				<el-table-column type="selection" width="55">
				</el-table-column>
				<el-table-column label="完成率">
					<template slot-scope="props">
						<el-progress type="circle" define-back-color="#EAF3FF" :percentage="props.row.taskTable" :width="60"
							:height="60" :stroke-width="6" :color="colors" style="transform: scale(0.8)"></el-progress>
					</template>
				</el-table-column>
				<el-table-column label="姓名/拼音">
					<template slot-scope="props">
						<span>{{ props.row.applicantName }}
							{{ props.row.surnameEn }} {{ props.row.nameEn }}</span>
					</template>
				</el-table-column>
				<el-table-column label="性别">
					<template slot-scope="props">
						<span>{{ props.row.gender }}</span>
					</template>
				</el-table-column>
				<el-table-column label="身份类型">
					<template slot-scope="props">
						<span>{{ props.row.identityTypeName }}</span>
					</template>
				</el-table-column>
				<el-table-column label="国籍">
					<template slot-scope="props">
						<span>{{ props.row.passportCountryName }}</span>
					</template>
				</el-table-column>
				<el-table-column label="护照号">
					<template slot-scope="props">
						<span>{{ props.row.passportNumber }}</span>
					</template>
				</el-table-column>
				<el-table-column label="出生日期">
					<template slot-scope="props">
						<span>{{
							props.row.birthday && props.row.birthday.split(" ")[0]
						}}</span>
					</template>
				</el-table-column>
				<el-table-column label="护照签发日">
					<template slot-scope="props">
						<span>{{
							props.row.passportIssue &&
							props.row.passportIssue.split(" ")[0]
						}}</span>
					</template>
				</el-table-column>
				<el-table-column label="护照到期日">
					<template slot-scope="props">
						<span>{{
							props.row.passportValidity &&
							props.row.passportValidity.split(" ")[0]
						}}</span>
					</template>
				</el-table-column>
			</el-table>
		</el-dialog>
	</div>
</template>

<script>
import {
	queryorderapplicants,
	addorderapplicants,
	upadateorderdeparturetime
} from "@/api/order.js";
import { query } from "@/api/personal.js";
import { orgorder } from "@/api/settings.js";

export default {
	name: 'applicantReuse',
	props: {
		visible: {
			type: Boolean,
			default: false
		},
		reuseData: {
			type: Object,
			default: () => { }
		}
	},
	watch: {
		visible(val) {
			if (val) {
				this.getListData()
			}
			this.dialogShow = val
		}
	},
	mounted() {
		this.handleGetordertools()
		this.departureTime = this.$moment().format("YYYY-MM-DD")
	},
	data() {
		return {
			dialogShow: false,
			tableData: [],
			colors: [
				{ color: "#E41313", percentage: 50 },
				{ color: "#EEBB17", percentage: 99 },
				{ color: "#1C9C1C", percentage: 100 },
			],
			productList: [],
			productloading: false,
			visaId: '',
			systemVisaId: '',
			tableSelect: [],
			departureTime: '', //预计出行时间
		}
	},
	methods: {
		handleDataChange(val) {
			console.log(val,123)
			if(!val){
				this.visaId = ''
				this.systemVisaId = ''
				return
			}
			let item = this.productList.find(item => item.id == val)
			console.log(item)
			this.systemVisaId = item.systemVisaId
			this.visaId = item.id

		},
		getListData() {
			queryorderapplicants({
				OrderId: this.reuseData.id,
				'Page.Size': 999,
				'Page.Index': 1,
			}).then(res => {
				console.log(res)
				this.tableData = res.data.rows
				this.$nextTick(() => {
					this.$refs.tableReuseRef.toggleAllSelection()
				})
			})
		},
		handleSelectionChange(val) {
			this.tableSelect = val
		},
		async submitSelectionUpload() {
			console.log(this.tableSelect)
			console.log(this.systemVisaId)
			if (this.systemVisaId !== '') {
				if (this.tableSelect.length > 0) {
					console.log(this.tableSelect)
					// 下单之后添加申请人
					let response = await orgorder({
						systemVisaId: this.systemVisaId,
					})

					if (response.code == 1) {
											
						// 修改出行时间
						let timeData = {
							departureTime: this.departureTime,
							orderId: response.data.id,
						}
						await upadateorderdeparturetime(timeData)


						let data = {
							orderId: response.data.id,
							DepartureTime: this.departureTime,
							applicants: this.tableSelect.map(item => {
								return {
									applicantName: item.applicantName,
									passportNumber: item.passportNumber,
									identityTypeId: item.identityType || 6,
									userApplicantId: item.id,
									passportInfo:{
										customer_SurnameEn: item.surnameEn,
										customer_SurName: item.surName,
										customer_Email: item.email,
										customer_NameEn: item.nameEn,
										customer_Name: item.name,
										customer_GenderName: item.gender,
										customer_Gender:item.gender == '女' ? 'F' : 'M',
										customer_BirthDay: item.birthday,
										customer_PassportIssue: item.passportIssue,
										customer_PassportValidity: item.passportValidity,
										passportUrl: item.passportUrl,
										customer_PassportNumber: item.passportNumber,
										customer_PassportCountryName: item.passportCountryName,
										customer_PassportCountry:item.passportCountry,
										avatarUrl:item.avatarUrl,
										customer_PassportProvinceEn:item.passportPlaceEn,
										customer_PassportProvinceName:item.passportPlace,
										customer_BirthPlace:item.birthPlace,
										customer_BirthPlaceEn:item.birthPlaceEn,

										// headPic
									},
								}
							})
						}
						console.log(data)
						let addresponse = await addorderapplicants(data)
						if (addresponse.code == 1) {
							this.$message.success('复用成功')
							this.dialogShow = false
							this.$emit('close', true)
						} else {
							this.$message.error(addresponse.msg)
						}
					} else {
						this.$message.error(response.msg)
					}
					console.log(response)
				} else {
					this.$message.error('请最少选择一个申请人')
				}
			} else {
				this.$message.error('请选择要复用的产品')
			}
		},
		handleClosed() {
			this.systemVisaId = ''
			this.visaId = ''
			this.tableSelect = []
			this.$emit('close')
		},
		closeFn() {
			this.dialogShow = false
			this.$emit('close')
		},
		// 获取机构产品数据
		handleGetordertools(e = '') {
			this.productloading = true;
			query({
				Title: e
			}).then(res => {
				if (res.code == 1) {
					this.productList = res.data.rows;
					console.log(this.productList,'产品列表')
				}
			}).finally(() => {
				this.productloading = false;
			})
		},
	}
}
</script>

<style lang="scss" scoped></style>

<style lang="scss">
.excel-dialog {

	.el-dialog {
		background-color: transparent;

		.el-dialog__header {
			display: none !important;
		}

		.el-dialog__body {
			background: linear-gradient(180deg, #e7ecfb 0%, #f6f8fe 24%, #ffffff 100%);
			border-radius: 12px;
			box-sizing: border-box;
			overflow: hidden;
		}
	}
}
</style>